import type {createBusinessRuntime} from '../../../packages/runtime/business-runtime.ts';
import type {
  SmtPrintingMutationResult,
  SmtPrintingViewModel,
} from '../../../packages/runtime/smt-printing-contract.ts';

type BusinessRuntime = ReturnType<typeof createBusinessRuntime>;
type PrintingRuntime = Pick<BusinessRuntime, 'smtPrinting'>;

export interface SmtPrintingPortConfig {
  readonly operatorId: string;
  readonly now: () => string;
  readonly nextPrintIntentId: () => string;
}

export interface SmtPrintingPort {
  readOrderPrinting(orderId:string):Promise<SmtPrintingViewModel>;
  reprintOrderPrint(orderId:string,sourceIntentId:string,reason:string):Promise<SmtPrintingMutationResult>;
  retryFailedOrderPrint(orderId:string,intentId:string,reason:string):Promise<SmtPrintingMutationResult>;
}

export function createSmtPrintingPort(
  runtime:PrintingRuntime,
  config:SmtPrintingPortConfig,
):SmtPrintingPort {
  const request=(orderId:string)=>({
    orderId,
    actorId:config.operatorId,
    at:config.now(),
  });
  const context=()=>({actorId:config.operatorId});

  return {
    async readOrderPrinting(orderId){
      return runtime.smtPrinting.snapshot(request(orderId));
    },
    async reprintOrderPrint(orderId,sourceIntentId,reason){
      return runtime.smtPrinting.reprint({
        ...request(orderId),
        sourceIntentId,
        newIntentId:config.nextPrintIntentId(),
        reason,
      },context());
    },
    async retryFailedOrderPrint(orderId,intentId,reason){
      return runtime.smtPrinting.retryFailed({
        ...request(orderId),
        intentId,
        reason,
      },context());
    },
  };
}
